import {EventEmitter, Injectable} from '@angular/core';
import {Constants, DOC_TAGS_POST_OP, DOC_TAGS_PRE_OP} from '../constants';
import {PatientCaseViewDataModel} from '../models/patient/patient-case-view-data.model';
import {NavigationStart, Router} from '@angular/router';
import {ReportGlobalParametersModel} from '../modules/reports/models/ReportGlobalParameters.model';
import {ReportStartUpInstructionsModel} from '../modules/reports/models/ReportStartUpInstructions.model';
import {ReportStartUpObjectModel} from '../modules/reports/models/ReportStartUpObject.model';
import {Globals} from '../globals';
import {HttpClient} from '@angular/common/http';
import {MenuMasterItemConfigurationModel} from '../models/ui/menu/menu-master-item-configuration.model';
import {MenuConfigurationModel} from '../models/ui/menu/menu-configuration.model';
import {MenuItemConfigurationModel} from '../models/ui/menu/menu-item-configuration.model';
import {AuthenticationService} from '../modules/auth/services/authentication.service';
import {DevicesService} from '../modules/configuration/devices/devices.service';
import {DeviceConfigurationModel} from '../models/configuration/device-configuration.model';
import {DesktopAcquireCommandsModel} from '../main-interface/imaging/models/desktop-acquire-commands.model';
import {LocalStorageService} from './local-storage.service';
import {TdoImagingService} from '../main-interface/imaging/tdo-imaging.service';
import {CaseTooth} from '../main-interface/imaging/models/CaseTooth';
import {SocketMessageModel} from './socket/models/socket-message.model';
import {MatDialog} from '@angular/material/dialog';
import {AccountingIntegrationComponent} from 'src/app/modules/ar/accounting-integration/accounting-integration.component'
import { environment } from 'src/environments/environment';
import { DOCUMENT_TAG } from '../models/constants/document-tag.model';
import { DEVICE_CATEGORY } from '../models/constants/device-category.model';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class UiService {
  selectedCaseItem: PatientCaseViewDataModel;

  enumPreops: string[] = DOC_TAGS_PRE_OP;
  enumPostops: string[] = DOC_TAGS_POST_OP;

  isShowNotes = true;
  isNotesOnLeft = false;
  isRightPanelMinimized = false;
  isShowTopDetails = true;
  isShowSearch = false;
  isCaseViewMinimized = false;
  isCheckOutViewMinimized = false;
  isChartViewMinimized = false;
  isHomeAccordionExpanded = true; 

  imagingWindow: Window;
  popUpWindows: any = [];

  devicesList: DeviceConfigurationModel[];
  tags: string[];
  messageUser: EventEmitter<SocketMessageModel> = new EventEmitter<SocketMessageModel>();

  constructor(private readonly router: Router,
              private readonly http: HttpClient,
              private readonly globals: Globals,
              private readonly authServer: AuthenticationService,
              private readonly devsService: DevicesService,
              private readonly localStorageService: LocalStorageService,
              private readonly aidialog: MatDialog,
              private readonly toastr: ToastrService,
              private readonly drawService: TdoImagingService) {
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart) {
        if (data.url === '/imaging' || data.url.includes('draw')) {
          this.isShowNotes = false;
        } else {
          this.isShowNotes = true;
        }

        if (data.url.includes('/imaging')) {
          this.isShowTopDetails = false;
        } else {
          this.isShowTopDetails = true;
        }

        if (data.url === '/landing/fees') {
          this.isCheckOutViewMinimized = false;
        }

        this.resetStates();
      }
    });
  }

  /**
 * Manages the global state for opening/closing CheckOutComponent
 * @param isOpen Indicates whether CheckOutComponent is open
 */
toggleCheckOutView(isOpen: boolean): void {
  this.isCheckOutViewMinimized = !isOpen;
  this.isCaseViewMinimized = isOpen;
  this.isHomeAccordionExpanded = !isOpen;
}

  openAccountingIntegrationWindow(isReload = false) {

        console.log("openning accounting intaragtion : eg. QuickBooks")



        this.aidialog.open(AccountingIntegrationComponent, {
          width: '80%',
          height: '80%'
        });
        // open dialog 80% screen
  }
  
  openImagingWindow(isReload = false) {
    localStorage.setItem('currentPatientCaseWorkItemIDForStudio', this.globals.currentPatientCaseWorkItemID);
    if (!this.imagingWindow || this.imagingWindow?.closed || isReload) {
      this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
    } else {
      this.imagingWindow.focus();
    }
  }
  handlePatientSwitchImagingWindowKEEP(isReload = false) {
    localStorage.setItem('currentPatientCaseWorkItemIDForStudio', this.globals.currentPatientCaseWorkItemID);
    if (!this.imagingWindow || this.imagingWindow?.closed || isReload) {
    } else {
      this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
    }
  }
  handlePatientSwitchImagingWindow(isReload = false) {
    localStorage.setItem('currentPatientCaseWorkItemIDForStudio', this.globals.currentPatientCaseWorkItemID);
    if (!this.imagingWindow || (this.imagingWindow && this.imagingWindow.closed) || isReload) {
    } else {
      this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
      this.imagingWindow.close();
    }
  }
  openAcquireDefaultDevice(tags: string[], isReload = false, isOpenImage = false) {
    // check the default device that is configured for this workstation
    // i.e. if Service Broker launch the desktop acquire else launch the studio
    this.tags = tags;
    let deviceCategoryId: string;
    const openingTag = this.tags[0]?.toUpperCase();
    // if tag is portrait, assign the device category for portrait
    if (openingTag === DOCUMENT_TAG.PatientPicture)
    {
      deviceCategoryId = DEVICE_CATEGORY.Portrait;;
    }
    //If tag is Insurance Payment doc, use scanner
    else if (openingTag === DOCUMENT_TAG.InsuranceCheck || this.tags[0] === DOCUMENT_TAG.InsuranceEOB)
    {
      deviceCategoryId = DEVICE_CATEGORY.Scanner;
    }
    else {
      // if not portrait then Radiology
      deviceCategoryId = DEVICE_CATEGORY.Radiology;
    }
    this.getWsDefaultDeviceData(deviceCategoryId, isReload, isOpenImage);
  }
  openAcquire(tags: string[], isReload = false) {
    // check the default device that is configured for this workstation
    // i.e. if Service Broker launch the desktop acquire else launch the studio
    this.tags = tags;
    let deviceCategoryId: string;
    // if tag is portrait, assign the device category for portrait
    if (this.tags[0] === DOCUMENT_TAG.PatientPicture)
    {
      deviceCategoryId = DEVICE_CATEGORY.Portrait;
    }
    else {
      this.getDeviceFromLocalStorage(isReload);
    }
    this.getWsDeviceData(null, isReload);

  }

  closePopupWindows(){
    var win = this.popUpWindows.shift();
    while(win != null){
      //console.log("closePopupWindows popup :", win.location)
      win.close();
      win = this.popUpWindows.shift();
    }
    if (this.imagingWindow != null)
      this.imagingWindow.close();
  }

  openReferralWindow() {
    var win = window.open('/landing/referrals', 'referrals', );
    this.popUpWindows.push(win);
  }

  openReportWindow(isReload = false) {
    const reportGlobalParameters = new ReportGlobalParametersModel();
    reportGlobalParameters.TDOCID = this.globals.TDOCID;
    reportGlobalParameters.LOCID = this.globals.LOCID;
    reportGlobalParameters.PatientID = this.globals.currentPatientId;
    reportGlobalParameters.PatientCaseID = this.globals.currentPatientCaseId;

    const reportStartUpInstructions = new ReportStartUpInstructionsModel();
    reportStartUpInstructions.enumReportCategoryID = '';
    reportStartUpInstructions.ReportID = '';
    reportStartUpInstructions.ShowViewer = true;
    reportStartUpInstructions.SavePDF = false;
    reportStartUpInstructions.Print = '';


    const reportStartUpObject = new ReportStartUpObjectModel();
    reportStartUpObject.reportStartUpInstructions = reportStartUpInstructions;
    reportStartUpObject.reportGlobalParameters = reportGlobalParameters;
    localStorage.setItem('object', JSON.stringify(reportStartUpObject));
    var win = window.open('/reports', '_blank', 'toolbar=1,location=0,menubar=1');
    this.popUpWindows.push(win);
  }

  openLettersWindow(option : OpenLettersOptions = {}) {

    var patientID=localStorage.getItem('currentPatientId');
    var caseID: any = localStorage.getItem('currentPatientCaseId');
    const parentCaseID=localStorage.getItem('currentParentPatientCaseId');
    const storedUser = JSON.parse(localStorage.getItem('storedUser'));
    const enterprise = localStorage.getItem('TDOEnterpriseId');
    const LOCID = localStorage.getItem('LOCID');

    if(parentCaseID!=null && parentCaseID.length>10){
      caseID=parentCaseID;
    }
    if(caseID!=null && caseID.length<10){
      caseID='00000000-0000-0000-0000-000000000000';
    }
    if(caseID==null){
      caseID='00000000-0000-0000-0000-000000000000';
    }
    if (patientID != null && storedUser != null && storedUser.authdata.userid != null) {
      const dt = new Date();
      const dtStr = dt.getUTCFullYear() + '-' + this.pad(dt.getUTCMonth() + 1, 2) + '-' + this.pad(dt.getUTCDate(), 2) + ' ' + this.pad(dt.getUTCHours(), 2) + ':' + this.pad(dt.getUTCMinutes(), 2);
      const operationName = 'TDOCloudLetters';
      const sharedKey = this.getSharedKey('TDOx' + '|' + '');
      const keyToHash = operationName + dtStr + sharedKey;
      const encoder = new TextEncoder();
      const sharedKeyBytes = encoder.encode(sharedKey);
      const dataToHmac = encoder.encode(keyToHash);
      let token = '';
      const bearer = localStorage.getItem('TDOauthToken');
      const hmacSha256 = window.crypto.subtle.importKey(
        'raw', sharedKeyBytes, { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']
      ).then((key: CryptoKey) => {
        window.crypto.subtle.sign(
          'HMAC', key, dataToHmac
        ).then((signature: ArrayBuffer) => {
          const hashVal = btoa(String.fromCharCode(...new Uint8Array(signature)));

          token = hashVal.replace('|', '#');
          const url = `${token}|TDOx|`;
          if (option.paramWebId !== undefined && option.paramWebId !== null )
          {
            var win = window.open(environment.lettersUrl + 'open-report/TDOx/' + caseID + '/'
          + patientID + ',' + enterprise + '/' + option.paramWebId +  '?token=' + url+'&bearer='+bearer+'&LOCID='+LOCID, '_blank', 'toolbar=1,location=0,menubar=1');
          this.popUpWindows.push(win);

          }
          else if(option.paramTaskMail !== undefined && option.paramTaskMail !== null){
            //opens Mail Center from Letters
            var win = window.open(environment.lettersUrl + 'new-letter/TDOx/' + caseID + '/'
          + patientID + ',_' + enterprise + '?token=' + url+'&bearer='+bearer +'&Mca=1'+'&LOCID='+LOCID, '_blank', 'toolbar=1,location=0,menubar=1');
          this.popUpWindows.push(win);
          }
          else {
            //letters will load from staging until deployed to prod
            var win = window.open(environment.lettersUrl + 'new-letter/TDOx/' + caseID + '/'
          + patientID + ',_' + enterprise + '?token=' + url+'&bearer='+bearer+'&LOCID='+LOCID, '_blank', 'toolbar=1,location=0,menubar=1');
          this.popUpWindows.push(win);
          }
        });
      });

    } else {
      // show message about selecting a patient
    }
  }

  openNotesWindow(patientId: string = null, patientCaseId: string = null) {

    if (patientId) {
      var win = window.open(`/notes/?patientId=${patientId}&patientCaseId=${patientCaseId}`, '_blank', 'toolbar=1,location=1,menubar=1');
      this.popUpWindows.push(win);
    } else {
      var win = window.open('/notes', '_blank', 'toolbar=1,location=1,menubar=1');
      this.popUpWindows.push(win);
    }
  }

  generateKey(){
    const dt = new Date();
    const dtStr = dt.getUTCFullYear() + '-' + this.pad(dt.getUTCMonth() + 1, 2) + '-' + this.pad(dt.getUTCDate(), 2) + ' ' + this.pad(dt.getUTCHours(), 2) + ':' + this.pad(dt.getUTCMinutes(), 2);
    const operationName = 'xxxx';
    const sharedKey = this.getSharedKey('TDOX' + '|' + '');
    const keyToHash = operationName + dtStr + sharedKey;

    return keyToHash;
  }
  private getSharedKey(input: string): string {
    return input + 'kUg%43vIds#xs';
  }
  private getHashVal(keyToHash: string, sharedKey: string){


  }

  private pad(num: number, size: number): string {
    let s = num.toString();
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }
  getMenuMasterItems() {
    return this.http.get<MenuMasterItemConfigurationModel[]>(`api/ui/get-master-items`);
  }

  saveMasterMenuItem(item: MenuMasterItemConfigurationModel) {
    return this.http.post<MenuMasterItemConfigurationModel>(`api/ui/save-master-item`, item);
  }

  deleteMasterMenuItem(item: MenuMasterItemConfigurationModel) {
    return this.http.post<MenuMasterItemConfigurationModel>(`api/ui/delete-master-item`, item);
  }

  getMenus() {
    return this.http.get<MenuConfigurationModel[]>(`api/ui/get-menus`);
  }

  saveMenu(menu: MenuConfigurationModel) {
    return this.http.post<MenuConfigurationModel>(`api/ui/save-menu`, menu);
  }

  deleteMenu(menu: MenuConfigurationModel) {
    return this.http.post<MenuConfigurationModel>(`api/ui/delete-menu`, menu);
  }

  getItems(menuId: string) {
    return this.http.get<MenuItemConfigurationModel[]>(`api/ui/get-items/${menuId}`);
  }

  saveItems(items: MenuMasterItemConfigurationModel[], menu: MenuConfigurationModel) {
    return this.http.post<MenuMasterItemConfigurationModel[]>(`api/ui/save-items`, { items, menu });
  }

  deleteItem(item: MenuMasterItemConfigurationModel, menu: MenuConfigurationModel) {
    return this.http.post<MenuItemConfigurationModel>(`api/ui/delete-item`, { items: [item], menu} );
  }

  reorderItems(items: MenuMasterItemConfigurationModel[], menu: MenuConfigurationModel) {
    return this.http.post<MenuConfigurationModel>(`api/ui/reorder-items`, { items, menu});
  }

  getMenu(name: string) {
    return this.http.get<MenuConfigurationModel>(`api/ui/get-menu/${name}`);
  }

  getUserMostUsedMenuItems(menu: string, userId: string) {
    return this.http.get<MenuItemConfigurationModel[]>(`api/ui/get-user-menu-items/${menu}/${userId}`);
  }

  updateMenuUsage(userId: string, itemId: string) {
    return this.http.post<void>(`api/ui/update-menu-usage`, {userId, itemId});
  }

  openPidWindow() {
    this.openNewTdoXProdWindow('d');
  }

  openCommsWindow() {
    this.openNewTdoXProdWindow('e');
  }

  openSchedulerWindow() {
    //
    var win = window.open('/scheduler', '_blank', 'toolbar=1,location=0,menubar=1');
    this.popUpWindows.push(win);
  }

  private openNewTdoXProdWindow(subdomainSuffix: string) {
    console.log('openNewTdoXProdWindow: ' + subdomainSuffix);
    let hostName: string = window.location.hostname;

    if (hostName.indexOf('localhost') < 0) {
      const arrHostName: string[] = hostName.split('.');
      hostName = '';
      let ind: number = 0;
      arrHostName.forEach((str: string) => {
        if (ind === 0) {
          hostName += str + '-' + subdomainSuffix;
        } else {
          hostName += '.' + str;
        }
        ind++;
      });
      hostName = 'https://' + hostName;
    } else {
      hostName = environment.TDOCommsURL;;
    }
    if (hostName.endsWith('/') )
      hostName = hostName.substring(0, hostName.length - 1);

    console.log('openNewTdoXProdWindow hostName: ' + hostName);
    this.authServer.autoLoginJwt().subscribe((token: string) => {
      let navUrl = hostName;
      if (token !== '') {
        navUrl += '/login/' + encodeURIComponent(token);
      } else {
        navUrl += '/login';
      }
      console.log('openNewTdoXProdWindow navUrl: ' + navUrl);

      var win = window.open(navUrl, '_blank');
      this.popUpWindows.push(win);
    });
  }
  getDeviceFromLocalStorage(isReload = false) {
    let storedDeviceId = localStorage.getItem('IMAGE_ACQUIRE_DEVICE');
    // if the tag is for patient picture just open studio
    if (this.tags[0] === DOCUMENT_TAG.PatientPicture)
    {
      storedDeviceId = null;
    }
    console.log('storedDeviceId ', storedDeviceId);
    if (!storedDeviceId) {
      if (!this.imagingWindow || (this.imagingWindow && this.imagingWindow.closed) || isReload) {
        this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
      } else {
        this.imagingWindow.focus();
      }
    } else {
      if (storedDeviceId === 'undefined') {
        if (!this.imagingWindow || (this.imagingWindow && this.imagingWindow.closed) || isReload) {
          this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
        } else {
          this.imagingWindow.focus();
        }

      } else {
        storedDeviceId = JSON.parse(storedDeviceId);
        this.getWsDeviceData(storedDeviceId, isReload);
      }
    }
  }
  getWsDeviceData( storedDeviceId: string, isReload = false) {
    const enumDeviceTwain: string = '00000261-1000-0000-0000-000000000001';
    const enumDeviceSB: string = '00000261-1000-0000-0000-000000000002';

    this.devsService.getWsDevice(storedDeviceId).subscribe(wsData => {
      const workstationsDevice = wsData[0];
      //  Check what kind of device, TWAIN or Service Broker.
      //  From the DeviceId, find the enumDeviceTypeID from deviceList

      this.devsService.getDevices(this.globals.LOCID).subscribe(ddata => {
        this.devicesList = ddata;
        const selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === workstationsDevice.DeviceID);
        if (selectedDevice.enumDeviceTypeID === enumDeviceTwain) {
          // twain
          if (!this.imagingWindow || (this.imagingWindow && this.imagingWindow.closed) || isReload) {
            this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
          } else {
            this.imagingWindow.focus();
          }

        }
        else if (selectedDevice.enumDeviceTypeID === enumDeviceSB) {
          // service broker
          console.log('device is service broker');
          this.callServiceBroker(selectedDevice, 'open_desk_top_acquire', () => {
            const intervalSubscription = setInterval(_ => {
              if (true) {
                clearInterval(intervalSubscription);
              }
            },  100);
          });

        }
      }, err => {
        console.log(err);
      });
    }, err => {
      console.log(err);
    });
  }
  getWsDefaultDeviceData( deviceCategoryId: string, isReload = false, isOpenImage = false) {
    console.log('getWsDefaultDeviceData deviceCategoryId ', deviceCategoryId);
    const enumDeviceTwain: string = '00000261-1000-0000-0000-000000000001';
    const enumDeviceSB: string = '00000261-1000-0000-0000-000000000002';
    

    this.devsService.getWsDeviceDefault(this.globals.WorkStationID, deviceCategoryId).subscribe(wsData => {
      console.log('getWsDefaultDeviceData wsData ', wsData);
      const workstationsDevice = wsData[0];
      //  Check what kind of device, TWAIN or Service Broker.
      //  From the DeviceId, find the enumDeviceTypeID from deviceList

      let  isTWAIN : boolean = false;

      this.devsService.getDevices(this.globals.LOCID).subscribe(ddata => {
        this.devicesList = ddata;
        const selectedDevice = null;
        if(this.devicesList===null || this.devicesList==undefined)
            {isTWAIN=true;}
        else
        {

          if(workstationsDevice != undefined)
          {
          const selectedDevice = this.devicesList.find(p => p.DeviceID.toString() === workstationsDevice.DeviceID);
          isTWAIN = selectedDevice.enumDeviceTypeID === enumDeviceTwain ||
                  (selectedDevice.enumDeviceTypeID.toUpperCase() === enumDeviceSB.toUpperCase() && deviceCategoryId.toUpperCase() === DEVICE_CATEGORY.Portrait) ||
                  (selectedDevice.enumDeviceTypeID.toUpperCase() === enumDeviceSB.toUpperCase() && isOpenImage);

                  localStorage.setItem('IMAGE_ACQUIRE_DEVICE', JSON.stringify(workstationsDevice.WorkStationDeviceID));
                  localStorage.setItem('is-Start-Folder-Monitor', JSON.stringify(workstationsDevice.isStartFolderMonitor));

          }
          else
          {isTWAIN=true;}


        }
        if (isTWAIN) {
          // twain
          localStorage.setItem('tags-imaging', JSON.stringify(this.tags));

          // localStorage.setItem('open-studio-from-landing', JSON.stringify('True'));
          if (!this.imagingWindow || (this.imagingWindow && this.imagingWindow.closed) || isReload) {
            this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');

          } else {
            this.imagingWindow.focus();
          }
          /*console.log('device is Twain');
          this.isTwainServiceStarted = false;
          const imgType = -1;
          this.newXray();*/
        }
        else if (selectedDevice === null)
          {
            localStorage.setItem('tags-imaging', JSON.stringify(this.tags));
   
            // localStorage.setItem('open-studio-from-landing', JSON.stringify('True'));
            if (!this.imagingWindow || (this.imagingWindow && this.imagingWindow.closed) || isReload) {
              this.imagingWindow = window.open('/studio', 'draw', 'toolbar=1,location=1,menubar=1');
            }
          }
        else if (selectedDevice?.enumDeviceTypeID === enumDeviceSB) {
          // service broker
          this.callServiceBroker(selectedDevice, 'open_desk_top_acquire', () => {
            const intervalSubscription = setInterval(_ => {
              if (true) {
                clearInterval(intervalSubscription);
              }
            },  100);
          });

        }
      }, err => {
        console.log(err);
      });
    }, err => {
      console.log(err);
    });
  }

  getDevices() {
    this.devsService.getDevices(this.globals.LOCID).subscribe(ddata => {
      this.devicesList = ddata;
    }, err => {
      console.log(err);
    });
  }
  callServiceBroker(selectedDevice: DeviceConfigurationModel, commandType: string, callback) {

    // get tooth number from currentPatientCaseWorkItemID or currentPatientCase
    let currentPatientCaseWorkItemID = Constants.emptyGuid;
    let toothDetail: CaseTooth[];
    if (this.globals.currentPatientCaseWorkItemID === '') {
      currentPatientCaseWorkItemID = Constants.emptyGuid;
    } else {
      currentPatientCaseWorkItemID = this.globals.currentPatientCaseWorkItemID;
    }
    console.log('currentPatientCase ' + this.globals.currentPatientCaseId);
    console.log('currentPatientCaseWorkItemID ' + this.globals.currentPatientCaseWorkItemID);
    this.drawService.getCaseTooth(this.globals.currentPatientCaseId, currentPatientCaseWorkItemID,
      this.globals.currentToothNumberingId).subscribe((caseToothModelResponse) => {

      if (caseToothModelResponse) {
        console.log('caseToothModelResponse ', caseToothModelResponse);
        toothDetail = caseToothModelResponse;

        const desktopAcquireCommandArgs: DesktopAcquireCommandsModel = new DesktopAcquireCommandsModel();
        desktopAcquireCommandArgs.PatientName = this.globals.currentPatientFullName;
        desktopAcquireCommandArgs.LocId = this.globals.LOCID;
        desktopAcquireCommandArgs.UserId = this.localStorageService.currentUserData.authdata.userid;
        desktopAcquireCommandArgs.PatientId = this.globals.currentPatientId;
        desktopAcquireCommandArgs.PatientCaseId = this.globals.currentPatientCaseId;
        desktopAcquireCommandArgs.ToothList = toothDetail;
        desktopAcquireCommandArgs.Tags = this.tags;
        if (selectedDevice !== undefined) {
          desktopAcquireCommandArgs.enumDeviceSBId = selectedDevice.enumDeviceSBID;
        }
        this.drawService.sendServiceBrokerCommand(desktopAcquireCommandArgs, commandType);
        setTimeout(() => {
          callback();
        }, 200);


        if (Object.keys(caseToothModelResponse).length === 0) {
          console.log('No tooth');
        }
      }

      // this.isReady = true;
    }, error => {
      // this.isReady = true;
    });

  }

  /**
 * Resets the global states
 */
resetStates(): void {
  this.isCheckOutViewMinimized = false;
  this.isCaseViewMinimized = false;
  this.isHomeAccordionExpanded = true;
}

displayMessage(type, message) {
  if (type.toLowerCase() === "error")
    this.toastr.error(message, null, { timeOut: 7000, positionClass:'toast-top-full-width', enableHtml: true });
  else if (type.toLowerCase() === "warning")
    this.toastr.warning(message, null, { timeOut: 5000, enableHtml: true  });
  else
    this.toastr.success(message, null, { timeOut: 3000, enableHtml: true  });
}

}

export interface OpenLettersOptions {
  paramWebId?: any;
  paramTaskMail?: any;
  // Add more parameters here in the future
}


